import React from "react";
import { QCFinding } from "../../types/qcTypes";
import MarkdownRedlineContent from "./MarkdownRedlineContent";
import QCFindingsView from "./QCFindingsView";

// Findings view for independent QC, used by IndependentQCDocumentView. Content
// here is always markdown/text (uploaded files parsed into blocks), so it
// renders through MarkdownRedlineContent only. Everything else is the shared
// QCFindingsView, the same as PanelQCResultsView.

interface IndependentQCResultsViewProps {
  findings: QCFinding[];
  sectionContent: string;
  sectionTitle: string;
  onAcceptFinding: (
    findingId: number,
    editedText?: string | null,
  ) => void | Promise<void>;
  onDeclineFinding: (findingId: number) => void | Promise<void>;
  onRevertFinding?: (findingId: number) => void | Promise<void>;
  onAcceptAll: () => void | Promise<void>;
  onDeclineAll: () => void | Promise<void>;
  onRevertAll?: () => void | Promise<void>;
  onSubmitFeedback?: (
    findingId: number,
    helpful: boolean,
  ) => void | Promise<void>;
  readOnly?: boolean;
  // When true, render markdown headings at their native level instead of
  // downgrading them. The document-mode flow (IndependentQCDocumentView) sets
  // true so headings in the merged content keep their visual hierarchy.
  preserveHeadings?: boolean;
}

const IndependentQCResultsView: React.FC<IndependentQCResultsViewProps> = ({
  findings,
  sectionContent,
  sectionTitle: _sectionTitle,
  ...rest
}) => (
  <QCFindingsView
    {...rest}
    findings={findings}
    renderContent={(components, className) => (
      <MarkdownRedlineContent
        findings={findings}
        sectionContent={sectionContent}
        components={components}
        className={className}
      />
    )}
  />
);

export default IndependentQCResultsView;
